const SENTIMENTS = {
  positive: "POSITIVE",
  negative: "NEGATIVE",
  neutral: "NEUTRAL",
};

export default SENTIMENTS;
